<template>
  <div>
    <div
      class="match-header text-white text-center d-flex flex-column position-relative text-shadow-accent"
      :style="{backgroundImage: 'url('+sport.bg+')'}"
    >
      <div v-if="showSportLogo" class="sport-info">
        <div class="sport-icon" v-html="sport?.svg"></div>
      </div>

      <template v-if="matchData?.isFutures">
        <div class="d-flex flex-column col justify-content-center align-items-center">
          <div class="antepost-title text-shadow-accent">{{ matchData?.inPlayMatchName }}</div>
          <div>{{ formatedDate }}</div>
        </div>
      </template>
      <template v-else>
        <!-- 3 teams/players view (like in golf) -->
        <div
          v-if="matchData?.secondPlayer && !['draw', 'vs', '@', 'tie'].includes(matchData?.secondPlayer.toLowerCase())"
          class="d-flex flex-column col justify-content-center align-items-center"
        >
          <div class="three-palayer-match-list fs-3">
            
            <div class="team-wr " :class="{'content-over': $store.state.isMobile }">
              <div v-if="matchData?.homeLogo" class="team-image"  >
                <img :src="matchData.homeLogo" />
              </div>
              <div class="team-name fs-3 text-ellipsies">{{matchData?.homeTeam}}</div>
            </div>
            <div class="team-wr" :class="{'content-over': $store.state.isMobile }">
              <div v-if="matchData?.secondPlayerLogo" class="team-image"  >
                <img :src="matchData.secondPlayerLogo" />
              </div>
              <div class="team-name fs-3 text-ellipsies">{{matchData?.secondPlayer}}</div>
            </div>
            <div class="team-wr" :class="{'content-over': $store.state.isMobile }">
              <div v-if="matchData?.awayLogo" class="team-image"  >
                <img :src="matchData.awayLogo" />
              </div>
              <div class="team-name fs-3 text-ellipsies">{{matchData?.awayTeam}}</div>
            </div>
          </div>
          <div class="text-center m-2 w-100 fs-12 fw-500 ">{{ formatedDate }}</div>
        </div>
        <!-- 2 teams/player view -->
        <div v-else class="d-flex justify-content-center align-items-center col p-2">

          <div class="team-wr w-50" :class="{'content-over': $store.state.isMobile }">
            <div v-if="matchData?.homeLogo" class="team-image"  >
              <img :src="matchData.homeLogo" />
            </div>
            <div class="team-name fs-3 text-ellipsies">{{matchData?.homeTeam}}</div>
          </div>

          <div class="m-2 match-date fs-12 fw-500 ">{{ formatedDate }}</div>

          <div class="team-wr w-50" :class="{'content-over': $store.state.isMobile }">
            <div v-if="matchData?.awayLogo" class="team-image">
              <img :src="matchData.awayLogo" />
            </div>
            <div class="team-name fs-3 text-ellipsies">{{ matchData?.awayTeam }}</div>
          </div>

        </div>
      </template>
    </div>

    <div v-if="sport.tabs && !matchData.isFutures" >
      <div >
        <div>
          <scroll-tabs-bar
            v-if="tabs.length"
            :items="tabs"
            :selected-item="selectedTab"
            @selectitem="selectTab"
          ></scroll-tabs-bar>
        </div>

        <div class="p-3 geoff-col-section"
          :class="{
            'rounded-3': !$store.state.isMobile,
            'screen-columns': (tabContent.length > 1)
          }
          ">
          <div >
            <div v-for="(type, index) in tabContent" :key="index" class="match-table section-item rounded-3">
              <div class="match-title sub-header p-n">{{type.elRespose}} <span   v-if="type.displayTwoUpLabel" class="label-2up ms-2">2up</span></div>
              <div class="match-row p-n" v-for="(res, index) in type?.events?.filter(ev=>ev.price)" :key="index">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{ res.selName }}</div>
                  <odd-btn :show-add-info="false" :race="res" :selection="parseInt(res.selection)" class="match-odd"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="p-3 geoff-col-section"
      :class="{
        'rounded-3': !$store.state.isMobile,
        'screen-columns': matchData?.fullcard?.length > 1
      }
      ">
      <div v-for="(type, index) in matchData.fullcard" :key="index" class="match-table section-item rounded-3">
        <div class="match-title sub-header p-n">{{type.elRespose}}</div>
        <div class="match-row p-n" v-for="(res, index) in type?.events?.filter(ev=>ev.price)" :key="index">
          <div class="d-flex justify-content-between align-items-center">
            <div>{{ res.selName }}</div>
            <odd-btn :show-add-info="false" :race="res" :selection="parseInt(res.selection)" class="match-odd"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import OddBtn from "@/components/UI/OddBtn";
  import ScrollTabsBar from "@/components/UI/ScrollTabsBar";
  import * as Utility from "@/http/utils"

  export default {
    name: "MatchEventFull",
    components: {
      OddBtn, 
      ScrollTabsBar
    },
    data:()=>{
      return{
        currentTab: '',
      }
    },
    props: {
      matchData: {
        type: Object,
        default: () => {return {}}
      },
      showSportLogo: {
        type: Boolean
      }
    },
    computed: {
      sport() {
        return this.API.SPORTS.find(sport => sport?.antePostCode === this.matchData.sportcode || sport?.code === this.matchData.sportcode)
      },
      tabs() {
        if(this.matchData?.fullcard?.length) {
          const availableMarkerts = this.matchData?.fullcard.map(el => el.elRespose.toLowerCase());
          const availableTabs = this.sport.tabs
            .filter(el => el.values
                .map(el => el.toLowerCase())
                .some(el => availableMarkerts.includes(el)))
            .map(el => el.label)
          return this.isOther ? [...availableTabs, 'Other'] : availableTabs
        }
        return []
      },

      tabContent() {
        if (this.selectedTab === 'Other') {
          const knownMarkets = this.sport.tabs
            .map(el => [...el.values.map(v => v.toLowerCase())])
            .flat();
          const otherMarkets = this.matchData?.fullcard?.filter(el => !knownMarkets.includes(el.elRespose.toLowerCase()))
          return otherMarkets;
        }
        else {
          const tabContent = this.matchData?.fullcard
            ?.filter(el => this.sport.tabs
              .find(t => t.label === this.selectedTab).values
              .map(v => v.toLowerCase())
              .includes(el.elRespose.toLowerCase()))
          return tabContent
        }
      },

      isOther() {
          if (this.matchData?.fullcard?.length) {
            const knownMarkets = this.sport.tabs
              .map(el => el.values)
              .flat()
              .map(el => el.toLowerCase())
            return  this.matchData?.fullcard
              .map(el => el.elRespose.toLowerCase())
              .some(el => !knownMarkets.includes(el))
          }
          return false;
      },
      selectedTab() {
        return this.currentTab || this.tabs[0];
      },
      formatedDate () {
        return Utility.FormatDateTime(this.matchData.date, this.matchData.time, true)
      }
    },
    methods:{
      selectTab(tab) {
        this.currentTab = tab;
      }
    }

  }
</script>

<style scoped lang="scss">
  
  .event-container {
    overflow: hidden;
  }

  .sport-info {
    position: absolute;
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
    top: 0.5rem;
    right: 0.5rem;

    .sport-icon {
      width: 1.375rem;
      height: 1.375rem;
      display: flex;
    }
  }

  ///
  .match-header{
    padding: 1rem;
    height: 9rem;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  
  .match-date {
    width: min-content;
    text-align: center;
    white-space: pre;
    line-height: 1.25rem;
  }

  .team-wr {
    flex: 1 1 50%;
    display: flex;
    align-items: center;
    grid-gap: 0 1rem;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;
    overflow: hidden;

    &.reverse {
      flex-direction: row-reverse;
    }

    &.content-over {
      flex-direction: column;
    }

    .team-image {
      width: 2.8125rem;
      height: 2.8125rem;
      display: flex;
      justify-content: center;
      align-items: center;
      object-fit: contain;
    }

    .team-name {
      max-width: 100%;
    }
  }

  .three-palayer-match-list {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
  }

  .antepost-title {
    font-size: 1.75rem;
  }
</style>